// extracted by mini-css-extract-plugin
export var afterHover = "index-module--afterHover--65e59";
export var black = "index-module--black--622ea";
export var current = "index-module--current--54198";
export var icon = "index-module--icon--71bb0";
export var text = "index-module--text--94eca";
export var textContainer = "index-module--textContainer--6beed";
export var white = "index-module--white--de2b1";